module.exports = require("@swa-ui/vacations/src/VacationsBookingHero/VacationsBookingHero.module.scss");